import { Controller } from '@hotwired/stimulus';

// 個人明細のメール送信モーダル(旧 main.js の form.sendPayslipModal)。
// パスワードを検証し、fetch で送信する。deliver は head :no_content を返すため
// フォームを通常送信すると Turbo がページ遷移として扱い画面が空になる(#2152)。
// fetch で送ることでその罠を回避する。
export default class extends Controller {
  static values = { userId: String };

  submit(event) {
    event.preventDefault();
    const form = this.element;
    const messages = form.querySelectorAll('.message');
    messages.forEach((m) => (m.style.display = 'none'));

    const passInput = form.querySelector('input[name=pass]');
    if (passInput) {
      const pass = passInput.value;
      if (pass === '') {
        this.showMessage('#bad-pass-message');
        return;
      }
      if (!/^[\x00-\x7F]+$/.test(pass)) {
        this.showMessage('#bad-pass-format');
        return;
      }
    }

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });

    this.showMessage('#pass-sent-message');
    const submitBtn = form.querySelector('button[type=submit], input[type=submit]');
    if (submitBtn) submitBtn.style.display = 'none';

    this.markSent();
  }

  showMessage(selector) {
    const el = this.element.querySelector(selector);
    if (el) el.style.display = 'block';
  }

  markSent() {
    const uid = this.userIdValue;
    const now = new Date();
    const message = `(${now.getMonth() + 1}月${now.getDate()}日に送信済)`;
    const container = document.getElementById(`mail_payslip_${uid}`);
    if (!container) return;
    const sentAt = container.querySelector('.sent_at');
    if (sentAt) {
      sentAt.textContent = message;
    } else {
      const div = document.createElement('div');
      div.className = 'sent_at';
      div.textContent = message;
      container.appendChild(div);
    }
  }
}
